var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }